import { inject, Injectable } from '@angular/core';
import { ColloquialAttributes } from '@shared/models/icommons.model';
import { UserInfoResolver } from '@shared/resolvers/user-info.resolver';
import { LookupRefService } from '@shared/services/lookup-ref.service';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class UserColloquialService {
  private readonly userInfoResolver = inject(UserInfoResolver);
  private readonly lookupRefService = inject(LookupRefService);
  private getUserCountrySkey(): string {
    // get active user userCountrySkey
    const user = this.userInfoResolver.resolve();
    return user.userCountrySkey.toString();
  }
  /**
   * Return Observable of ColloquialAttributes for a given user country
   * @returns
   */
  private toColloquialAttributes(
    countrySkey: string
  ): (colloquial: { [key: string]: ColloquialAttributes }) => ColloquialAttributes {
    // return and return ColloquialAttributes
    return colloquialCountryMap => colloquialCountryMap[countrySkey];
  }
  /**
   * Return Observable of ColloquialAttributes for a given user country
   * @returns
   */
  getUserColloquial(): Observable<ColloquialAttributes> {
    // get user country skey
    const countrySkey = this.getUserCountrySkey();
    // fetch colloquial attributes for user country skey
    return this.getColloquialMap(countrySkey).pipe(map(this.toColloquialAttributes(countrySkey)), take(1));
  }
  /**
   * Return Observable of ColloquialAttributes for a given countrySkey OR if not provided all possible available in application
   * @returns
   */
  getColloquialMap(countrySkey?: string): Observable<{ [key: string]: ColloquialAttributes }> {
    return this.lookupRefService.getColloquial(countrySkey);
  }
}
